// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: rgba(0, 0, 0, 0.9);
}
:host ion-header {
  background-color: transparent !important;
}
:host ion-header ion-toolbar {
  --background:rgba(0, 0, 0, 0.9) !important;
}
:host ion-header ion-toolbar ion-button {
  --color: #fff !important;
}
:host ion-header ion-toolbar ion-title {
  color: #fff !important;
}
:host ion-header ion-toolbar .button {
  color: #fff !important;
  background-color: transparent !important;
  position: relative;
  padding: 0 5px;
  --cms-header-icon-color: white;
}
:host ion-content {
  display: contents;
  --background: transparent;
  background-color: transparent !important;
}
.plt-desktop :host ion-content {
  --background: var(--cms-web-bg-color);
}
:host iframe, :host video {
  display: block;
  margin: calc(45px + env(safe-area-inset-top)) auto 0;
  height: calc(100vh - (45px + env(safe-area-inset-top)));
}

.fullscreen-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: #000;
}

ion-content {
  --background: #000;
}

video {
  background: #000;
}
video::-webkit-media-controls {
  background-color: rgba(0, 0, 0, 0.5);
}
video::-webkit-media-controls-panel {
  background-color: rgba(0, 0, 0, 0.5);
}

.video-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - (45px + env(safe-area-inset-top)));
  text-align: center;
  padding: 20px;
}
.video-error h2 {
  margin-bottom: 10px;
  color: #fff;
}
.video-error p {
  margin-bottom: 20px;
  color: #ccc;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - (45px + env(safe-area-inset-top)));
  text-align: center;
  padding: 20px;
}
.loading-container ion-spinner {
  margin-bottom: 20px;
  --color: #fff;
}
.loading-container p {
  color: #fff;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gallery/video-player/video-player.scss"],"names":[],"mappings":"AAAA;EAEE,8BAAA;AAAF;AAEE;EACE,wCAAA;AAAJ;AACI;EACE,0CAAA;AACN;AAAM;EACE,wBAAA;AAER;AAEM;EACE,sBAAA;AAAR;AAGM;EACE,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AADR;AAME;EACI,iBAAA;EACA,yBAAA;EACJ,wCAAA;AAJF;AAKM;EACI,qCAAA;AAHV;AAOE;EACI,cAAA;EACA,oDAAA;EACA,uDAAA;AALN;;AAUA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AAPA;;AAUA;EACA,kBAAA;AAPA;;AAUA;EACA,gBAAA;AAPA;AASA;EACE,oCAAA;AAPF;AAUA;EACE,oCAAA;AARF;;AAYA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uDAAA;EACA,kBAAA;EACA,aAAA;AATA;AAWA;EACE,mBAAA;EACA,WAAA;AATF;AAYA;EACE,mBAAA;EACA,WAAA;AAVF;;AAcA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uDAAA;EACA,kBAAA;EACA,aAAA;AAXA;AAaA;EACE,mBAAA;EACA,aAAA;AAXF;AAcA;EACE,WAAA;EACA,SAAA;AAZF","sourcesContent":[":host {\n\n  background: rgba(0, 0, 0, 0.9);\n\n  ion-header {\n    background-color: transparent !important;\n    ion-toolbar {\n      --background:rgba(0, 0, 0, 0.9) !important;\n      ion-button {\n        --color: #fff !important;\n      }\n      \n\n      ion-title {\n        color: #fff !important;\n      }\n\n      .button {\n        color: #fff !important;\n        background-color: transparent !important;\n        position: relative;\n        padding: 0 5px;\n        --cms-header-icon-color: white;\n      }\n    }\n  }\n\n  ion-content{\n      display: contents;\n      --background: transparent;\n  background-color: transparent !important;\n      .plt-desktop &  {\n          --background: var(--cms-web-bg-color);\n      }\n\n  }\n  iframe, video{\n      display: block;\n      margin: calc(45px + env(safe-area-inset-top)) auto 0;\n      height: calc(100vh - calc(45px + env(safe-area-inset-top)));\n\n    }\n}\n\n.fullscreen-video {\nposition: fixed;\ntop: 0;\nleft: 0;\nwidth: 100vw;\nheight: 100vh;\nz-index: 9999;\nbackground: #000;\n}\n\nion-content {\n--background: #000;\n}\n\nvideo {\nbackground: #000;\n\n&::-webkit-media-controls {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n&::-webkit-media-controls-panel {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n}\n\n.video-error {\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nheight: calc(100vh - calc(45px + env(safe-area-inset-top)));\ntext-align: center;\npadding: 20px;\n\nh2 {\n  margin-bottom: 10px;\n  color: #fff;\n}\n\np {\n  margin-bottom: 20px;\n  color: #ccc;\n}\n}\n\n.loading-container {\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nheight: calc(100vh - calc(45px + env(safe-area-inset-top)));\ntext-align: center;\npadding: 20px;\n\nion-spinner {\n  margin-bottom: 20px;\n  --color: #fff;\n}\n\np {\n  color: #fff;\n  margin: 0;\n}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
